const word = [{
    word: "hello",
    phonetic: "/həˈləʊ/",
    phonetics: [
        {
            text: "/həˈləʊ/",
            audio: "//ssl.gstatic.com/dictionary/static/sounds/20200429/hello--_gb_1.mp3"
        },
        {
            text: "/hɛˈləʊ/"
        }
    ],
    origin: "early 19th century: variant of earlier hollo ; related to holla.",
    meanings: [
        {
            partOfSpeech: "noun",
            synonyms: ['hey', ' sup', ' yo', ' moin'],
            antonyms: [],
            definitions: [
                {
                    definition: "an utterance of ‘hello’; a greeting.",
                    example: "She was getting polite nods and hellos from people.",
                }
            ]
        },
        {
            partOfSpeech: "verb",
            synonyms: [],
            antonyms: [],
            definitions: [
                {
                    definition: "say or shout ‘hello’.",
                    example: "I pressed the phone button and helloed.",
                }
            ]
        },
        {
            partOfSpeech: "exclamation",
            synonyms: [],
            antonyms: [],
            definitions: [
                {
                    definition: "used as a greeting or to begin a phone conversation.",
                    example: "Hello there, Katie!",
                }
            ]
        },
    ]
}]

export default word